import { Box, Typography } from '@mui/material';
import { BracketSeedMatchGameEntity } from 'app/interfaces/entity';
import { ManageTournamentMatchResultsForm } from './ManageTournamentMatchResultsForm';
import React, { FC } from 'react';
import { useStyles } from './TournamentMatchAdminTab.styles';

interface TournamentMatchAdminTabProps {
  matchGames: BracketSeedMatchGameEntity[];
}

export const TournamentMatchAdminTab: FC<TournamentMatchAdminTabProps> = ({ matchGames }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Typography pb={1}>Manage Scores</Typography>
      <ManageTournamentMatchResultsForm matchGames={matchGames} />
    </Box>
  );
};
